module.exports = __webpack_public_path__ + "background_section.bf50f74d0e2e1fde97b6.png";


//////////////////
// WEBPACK FOOTER
// C:/Users/TerrellDavis/Documents/GitHub/AVL/realavl/realavl/src/img/background_section.png
// module id = ../../../../../src/img/background_section.png
// module chunks = styles